import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "泰国腐剧", to: "/category/泰国腐剧" },
  { label: "双男主影视", to: "/tags/双男主" },
  { label: "最新更新", to: "/category/最新更新" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

const tagLinks = ["双男主", "青春校园", "甜宠", "虐恋", "治愈", "悬疑"];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50/15">
                <i className="ri-heart-3-fill text-lg text-primary-200"></i>
              </span>
              <span className="font-heading text-lg font-extrabold text-background-50">泰剧腐剧双男主</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              专注泰国双男主题材影视的内容聚合平台，为你提供最新的剧情介绍、角色解析、影视资讯与剧集推荐，帮助你高效了解并选择心仪的作品。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-200/80">
              <i className="ri-mail-line"></i>contact@thaibldrama.com
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200/80 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">热门标签</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {tagLinks.map((tag) => (
                <Link
                  key={tag}
                  to={`/tags/${tag}`}
                  className="rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 text-xs text-background-100 transition-colors hover:bg-background-50/20 cursor-pointer whitespace-nowrap"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-200/70">
            © {new Date().getFullYear()} 泰剧腐剧双男主 · 本站为影视资讯与内容推荐平台，不提供在线播放服务。
          </p>
          <p className="text-xs text-background-200/70">内容仅供学习交流，版权归原作者所有。</p>
        </div>
      </div>
    </footer>
  );
}